export default {
  default: "Toast_DefaultError",
  unauthorized: "Toast_Unauthorized",
  logout: "Toast_Logout",
  login: "Toast_Login",
  register: "Toast_Register",
  "reset-password": "Toast_ResetPassword",
  "form/submitted": "Toast_Form_Submitted",
  "form/updated": "Toast_Form_Updated",
  "form/deleted": "Toast_Form_Deleted",
  "form/missing-some-fields": "Toast_Form_MissingFields",
  "cloud-payments/user-has-cancelled": "Toast_UserDropSubscription",
  "cloud-payments/not-found": "Toast_ServerIssue",
  "auth/user-not-found": "Toast_Auth_UserNotFound",
  "auth/wrong-password": "Toast_Auth_WrongPassword",
  "auth/email-already-in-use": "Toast_Auth_EmailExists"
};
